const normalizeSrc = (src) => {
  return src.startsWith('/') ? src.slice(1) : src;
};

export default function (path) {
  return `${process.env.IMAGE_URL}/${normalizeSrc(path)}/public`;
}
